module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-toast-alcohol-58e0f00f122c36011eb0a7cc0322fbca.png";